import imageBanner from "../../assets/images/dicas-de-decoracao-diy-para-voce-fazer-e-decorar-sua-casa.jpg";
import image1 from "../../assets/images/banner/image1.png";
import image2 from "../../assets/images/banner/image2.png";
import image3 from "../../assets/images/banner/image3.png";
import image4 from "../../assets/images/banner/image4.png";
import image5 from "../../assets/images/banner/image5.png";
import image6 from "../../assets/images/banner/image6.png";
import image7 from "../../assets/images/banner/image7.png";
import image8 from "../../assets/images/banner/image8.png";
import image9 from "../../assets/images/banner/image9.png";
import image10 from "../../assets/images/banner/image10.png";
import image11 from "../../assets/images/banner/image11.png";
import image12 from "../../assets/images/banner/image12.png";
import image13 from "../../assets/images/banner/image13.png";
import image14 from "../../assets/images/banner/image14.png";
import image15 from "../../assets/images/banner/image15.png";
import image16 from "../../assets/images/banner/image16.png";
import image17 from "../../assets/images/banner/image17.png";
import image18 from "../../assets/images/banner/image18.png";
import image19 from "../../assets/images/banner/image19.png";

export const banners = [
  {
    value: 1,
    image: image1
  },
  {
    value: 2,
    image: image2
  },
  {
    value: 3,
    image: image3
  },
  {
    value: 4,
    image: image4
  },
  {
    value: 5,
    image: image5
  },
  {
    value: 6,
    image: image6
  },
  {
    value: 7,
    image: image7
  },
  {
    value: 8,
    image: image8
  },
  {
    value: 9,
    image: image9
  },
  {
    value: 10,
    image: image10
  },
  {
    value: 11,
    image: image11
  },
  {
    value: 12,
    image: image12
  },
  {
    value: 13,
    image: image13
  },
  {
    value: 14,
    image: image14
  },
  {
    value: 15,
    image: image15
  },
  {
    value: 16,
    image: image16
  },
  {
    value: 17,
    image: image17
  },
  {
    value: 18,
    image: image18
  },
  {
    value: 19,
    image: image19
  }
];
